import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Resolve
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { FormShareService } from '../services/share.service';

@Injectable()
export class FormPayeeResolver implements Resolve<number> {
  constructor(private formService: FormShareService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<number> {
    this.formService.payingContactIndex = parseInt(
      route.queryParams['payee'],
      10
    );

    return of(route.queryParams['payee']);
  }
}
